import { useState } from 'react'
import {
    Button,
    Chip,
    CircularProgress,
    Container,
    Grid,
    Typography
} from '@mui/material'
// import type { GridColDef } from '@mui/x-data-grid'
import DrawerLongWidth from 'components/drawerLongWidth/detail'
import GLOBAL from 'modules/global'
import Drawer from 'components/drawer/detail'
import Loading from 'components/loading/loading'
import { downloadByUrl } from 'store/api'
import Notification from 'components/notification'
import type { DetailStateProps } from 'modules/types'
import {
    useGetDetailServiceBookingQuery,
    useGetInvoiceMutation
} from 'store/bookingService'
import DrawerStyle from './style'


type TransactionStatus = 'Waiting for Payment' | 'Reservation on Going' | 'Service on Process' | 'Completed' | 'Cancel';
type RepairStatus = 'Waiting for Payment' | 'Reservation' | 'Service Preparation' | 'Service Process' | 'Service Completed' | 'Delivery Preparation' | 'Vehicle Delivered' | 'Closed';
type PaymentStatus = 'Settlement' | 'In Progress' | 'Cancel' | 'Failed';

const Details = ({ open, id, onClose }: DetailStateProps & { id: string | number }) => {
    const [notification, setNotification] = useState({ open: false, message: '', isError: false });
    const [loadingInvoice, setLoadingInvoice] = useState(false);

    // const { data, isFetching, isLoading } = useGetDetailServiceBookingQuery(Number(id));
    const { data, isFetching, isLoading } = useGetDetailServiceBookingQuery(Number(id), { skip: !open });
    const loading = !data && (isLoading || isFetching);
    const [downloadInvoice] = useGetInvoiceMutation();

    if (!open) {
        return <Drawer open={open} onClose={onClose} />
    }

    // const id_ = (data && data.id) || 0
    const memberID_ = (data && data.memberCode) || '-'
    const bookingCode_ = (data && data.bookingCode) || '-'
    const createdAt_ = (data && data.createdAt) || '-'
    const vehicleLicensePlate_ = (data && data.vehicleLicensePlate) || '-'
    const appointmentConfirmation_ = (data && data.appointmentConfirmation) || '-'
    const vin_ = (data && data.vin) || '-'
    const vehicleModelName_ = (data && data.vehicleModelName) || '-'
    const odometer_ = (data && data.odometer) || '-'
    const customerName_ = (data && data.customerName) || '-'
    const customerPhone_ = (data && data.customerPhone) || null
    const contactName_ = (data && data.contactName) || '-'
    const contactPhone_ = (data && data.contactPhone) || null
    const repairNo_ = (data && data.repairNo) || '-'
    const repairSelection_ = (data && data.repairSelection) || '-'
    const servicePackage_ = (data && data.servicePackage) || '-'
    const eventName_ = (data && data.eventName) || '-'
    const customerType_ = (data && data.customerType) || '-'
    const insuranceName_ = (data && data.insuranceName) || '-'
    const note_ = (data && data.serviceStatusNotes) || '-'
    const repairConfirmation_ = (data && data.repairConfirmation) || '-'
    const repairStatus_ = (data && data.repairStatus === 'Closed') ? 'Closed' :
        (data && data.repairStatus === 'WaitingforPayment') ? 'Waiting for Payment' :
            (data && data.repairStatus === 'Waiting For Payment') ? 'Waiting for Payment' :
                (data && data.repairStatus === 'ServicePreparation') ? 'Service Preparation' :
                    (data && data.repairStatus === 'ServiceProcess') ? 'Service Process' :
                        (data && data.repairStatus === 'ServiceCompleted') ? 'Service Completed' :
                            (data && data.repairStatus === 'DeliveryPreparation') ? 'Delivery Preparation' :
                                (data && data.repairStatus === 'VehicleDelivered') ? 'Vehicle Delivered' :
                                    (data && data.repairStatus) || '-';
    const transactionStatus_ = (data && data.transactionStatus === 'Cancel') ? 'Cancel' :
        (data && data.repairStatus === 'WaitingforPayment') ? 'Waiting for Payment' :
            (data && data.repairStatus === 'Waiting For Paymen') ? 'Waiting for Payment' :
                (data && data.transactionStatus === 'ReservationOnGoing') ? 'Reservation on Going' :
                    (data && data.transactionStatus === 'Service on Process') ? 'Service on Process' :
                        (data && data.transactionStatus === 'Completed') ? 'Completed' :
                            (data && data.transactionStatus) || '-';

    const deliveryMethod_ = (data && data.deliveryMethod) || '-'
    const serviceAddress_ = (data && data.serviceAddress) || '-'
    const reservationDate_ = (data && data.reservationDate) || '-'
    // const waitingForReceivedDate_ = (data && data.waitingForReceivedDate) || '-'
    const servicePreparationDate_ = (data && data.servicePreparationDate) || '-'
    const serviceProcessDate_ = (data && data.serviceProcessDate) || '-'
    const serviceCompletedDate_ = (data && data.serviceCompletedDate) || '-'
    const deliveryPreparationDate_ = (data && data.deliveryPreparationDate) || '-'
    const vehicleDeliveredDate_ = (data && data.vehicleDeliveredDate) || '-'
    const cancelationDate_ = (data && data.cancelationDate) || '-'
    const cancelationReason_ = (data && data.cancelationReason) || '-'
    const dealerName_ = (data && data.dealerName) || '-'
    const dealerPhone_ = (data && data.dealerPhone) || '-'
    const serviceAdvisorName_ = (data && data.serviceAdvisorName) || '-'
    const promoApplliedLabor_ = (data && data.promoApplliedLabor) || '-' //Blum ada propertynya
    const promoApplliedPart_ = (data && data.promoApplliedPart) || '-'  //Blum ada propertynya
    const serviceList_ = (data && data.serviceList) || '-'
    const invoiceNo_ = (data && data.invoiceNo) || '-'
    const paymentStatus_ = (data && data.paymentStatus === 'settlement') ? 'Settlement' : '-'
    const paymentMethod_ = (data && data.paymentMethod) || '-'
    const totalPrice_ = (data && data.totalPrice) || 0
    const servicesFee_ = (data && data.servicesFee) || 0
    const totalPromoApplied_ = (data && data.totalPromoApplied) || 0 //Blum ada propertynya
    const tax_ = (data && data.tax) || 0
    const grandTotal_ = (data && data.grandTotal) || 0
    const paymentDate_ = (data && data.paymentDate) || '-'
    const source_ = (data && data.source) || '-'
    const sourceType_ = (data && data.sourceType) || '-'

    const onPress = async () => {
        setLoadingInvoice(true); // Set loading state to true
        try {
            const response = await downloadInvoice(Number(id)).unwrap();
            if (!response) {
                setNotification({ open: true, message: 'Error: No content available to download.', isError: true });
                return;
            } else {
                downloadByUrl(response);
                setNotification({ open: true, message: 'Success Download Invoice.', isError: false });
            }
        } catch (error) {
            console.error('Download failed:', error);
            setNotification({ open: true, message: 'Failed to download invoice. Please try again later.', isError: true });
        } finally {
            setLoadingInvoice(false); // Reset loading state
        }
    };

    // const formatCurrencys = (value: number) =>
    //     value ? value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') : '0'

    const formatCurrency = (value: number) => {
        if (value < 0) {
            return `- Rp ${Math.abs(value).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}`;
        }
        return `Rp ${value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}`;
    }

    const formatPhone = (input: string) => {
        input = input.replace(/[^\d+]/g, '');
        if (input.startsWith('+62')) {
            input = '0' + input.slice(3);
        }
        // Format the number by inserting space every 4 digits
        let formatted = '';
        const length = input.length;
        for (let i = 0; i < length; i += 4) {
            formatted += input.slice(i, i + 4);
            if (i + 4 < length) {
                formatted += ' ';
            }
        }
        return formatted;
    }

    const transactionStatusColors: Record<TransactionStatus, { backgroundColor: string; color: string }> = {
        'Waiting for Payment': { backgroundColor: '#FE9900', color: '#fff' },
        'Reservation on Going': { backgroundColor: '#00AAD2', color: '#fff' },
        'Service on Process': { backgroundColor: '#FAD543', color: '#fff' },
        'Completed': { backgroundColor: '#7DDA58', color: '#fff' },
        'Cancel': { backgroundColor: '#FF090B', color: '#fff' }
    };

    const repairStatusColors: Record<RepairStatus, { backgroundColor: string; color: string }> = {
        'Waiting for Payment': { backgroundColor: '#FE9900', color: '#fff' },
        'Reservation': { backgroundColor: '#00AAD2', color: '#fff' },
        'Service Preparation': { backgroundColor: '#FAD543', color: '#fff' },
        'Service Process': { backgroundColor: '#FAD543', color: '#fff' },
        'Service Completed': { backgroundColor: '#FAD543', color: '#fff' },
        'Delivery Preparation': { backgroundColor: '#FAD543', color: '#fff' },
        'Vehicle Delivered': { backgroundColor: '#7DDA58', color: '#fff' },
        'Closed': { backgroundColor: '#D20103', color: '#fff' }
    };

    const paymentStatusColors: Record<PaymentStatus, { backgroundColor: string; color: string }> = {
        'Settlement': { backgroundColor: '#00AAD2', color: '#fff' },
        'In Progress': { backgroundColor: '#FE9900', color: '#fff' },
        'Cancel': { backgroundColor: '#FF090B', color: '#fff' },
        'Failed': { backgroundColor: '#D20103', color: '#000' }
    };

    return (
        <>
            <DrawerLongWidth open={open} title='Detail Book Car Service Transaction' onClose={onClose} maxWidth='lg'>
                <Container {...DrawerStyle.Container}>
                    {loading && <Loading />}
                    {!loading && (
                        <>
                            <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 1, md: 2 }}>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Member ID</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{memberID_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Booking Code</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{bookingCode_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Created Date</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{GLOBAL.formatDateWithTimeSecond(createdAt_)}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>License Plate</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{vehicleLicensePlate_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Appointment Confirmation Status</Typography>
                                    {appointmentConfirmation_ === 'Confirmed' || appointmentConfirmation_ === 'Confirm' ? (
                                        <Chip
                                            label={<Typography style={{ fontWeight: '400' }}>{'Confirm'}</Typography>}
                                            color='success'
                                        />
                                    ) : appointmentConfirmation_ === 'NotConfirm' || appointmentConfirmation_ === 'Not Confirm' ? (
                                        <Chip
                                            label={<Typography style={{ fontWeight: '400' }}>{'Not Confirm'}</Typography>}
                                            color='error'
                                        />
                                    ) : (
                                        <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}>
                                            <strong>-</strong>
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>VIN</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{vin_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Car Model</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{vehicleModelName_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Odometer</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{odometer_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Customer Name</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{customerName_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Customer Phone</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{customerPhone_ ? formatPhone(customerPhone_) : '-'}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Contact Person Name</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{contactName_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Contact Person Phone</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{contactPhone_ ? formatPhone(contactPhone_) : '-'}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>DMS Repair No</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{repairNo_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Repair Type</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{repairSelection_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Service Package</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{servicePackage_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Event Name</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{eventName_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Customer Type</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{customerType_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Insurance Name</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{insuranceName_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Note</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{note_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Repair Confirmation</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{repairConfirmation_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Transaction Status</Typography>
                                    {transactionStatus_ !== '-' ? (
                                        <Chip
                                            // label={transactionStatus_}
                                            label={<Typography style={{ fontWeight: '400', color: transactionStatusColors[transactionStatus_ as TransactionStatus]?.color || '#000' }}>{transactionStatus_}</Typography>}
                                            sx={{
                                                backgroundColor: transactionStatusColors[transactionStatus_ as TransactionStatus]?.backgroundColor || '#e0e0e0',
                                                color: transactionStatusColors[transactionStatus_ as TransactionStatus]?.color || '#000',
                                            }}
                                        />
                                    ) : (
                                        <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}>
                                            <strong>-</strong>
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Repair Status</Typography>
                                    {repairStatus_ !== '-' ? (
                                        <Chip
                                            // label={repairStatus_}
                                            label={<Typography style={{ fontWeight: '400', color: repairStatusColors[repairStatus_ as RepairStatus]?.color || '#000' }}>{repairStatus_}</Typography>}
                                            sx={{
                                                backgroundColor: repairStatusColors[repairStatus_ as RepairStatus]?.backgroundColor || '#e0e0e0',
                                                color: repairStatusColors[repairStatus_ as RepairStatus]?.color || '#000',
                                            }}
                                        />
                                    ) : (
                                        <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}>
                                            <strong>-</strong>
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Delivery Method</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{deliveryMethod_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Service Location</Typography>
                                    <Typography
                                        style={{
                                            color: '#000000',
                                            fontSize: 16,
                                            fontWeight: '500',
                                            overflowWrap: 'break-word',
                                            wordBreak: 'break-word',
                                            maxWidth: '70%',
                                            whiteSpace: 'normal'
                                        }}
                                    >
                                        <strong>{serviceAddress_}</strong>
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Reservation</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{GLOBAL.formatDateWithTimeSecond(reservationDate_)}</strong></Typography>
                                </Grid>
                                {/* <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Waiting for Received</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{GLOBAL.formatDateWithTimeSecond(waitingForReceivedDate_)}</strong></Typography>
                                </Grid> */}
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Service Preparation</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{GLOBAL.formatDateWithTimeSecond(servicePreparationDate_)}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Service Process</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{GLOBAL.formatDateWithTimeSecond(serviceProcessDate_)}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Service Completed</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{GLOBAL.formatDateWithTimeSecond(serviceCompletedDate_)}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Delivery Preparation</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{GLOBAL.formatDateWithTimeSecond(deliveryPreparationDate_)}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Vehicle Delivered</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{GLOBAL.formatDateWithTimeSecond(vehicleDeliveredDate_)}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Cancel</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{GLOBAL.formatDateWithTimeSecond(cancelationDate_)}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Cancelation Reason</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{cancelationReason_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Dealer Name</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{dealerName_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Dealer Phone</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{dealerPhone_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Service Advisor</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{serviceAdvisorName_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Service List</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{serviceList_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Promo Applied - Labor</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{promoApplliedLabor_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Promo Applied - Part</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{promoApplliedPart_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Payment Status</Typography>
                                    {paymentStatus_ !== '-' ? (
                                        <Chip
                                            // label={paymentStatus_}
                                            label={<Typography style={{ fontWeight: '400', color: paymentStatusColors[paymentStatus_ as PaymentStatus]?.color || '#000' }}>{paymentStatus_}</Typography>}
                                            sx={{
                                                backgroundColor: paymentStatusColors[paymentStatus_ as PaymentStatus]?.backgroundColor || '#e0e0e0', // Default color
                                                color: paymentStatusColors[paymentStatus_ as PaymentStatus]?.color || '#000', // Default text color
                                            }}
                                        />
                                    ) : (
                                        <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}>
                                            <strong>-</strong>
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid item xs={6} style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', maxWidth: '70%' }}>
                                            <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Invoice No</Typography>
                                            <Typography
                                                style={{
                                                    color: '#000000',
                                                    fontSize: 16,
                                                    fontWeight: '500',
                                                    overflowWrap: 'break-word',
                                                    wordBreak: 'break-word',
                                                    maxWidth: '70%',
                                                    whiteSpace: 'normal'
                                                }}
                                            >
                                                <strong>{invoiceNo_}</strong>
                                            </Typography>
                                        </div>
                                        <Button
                                            variant='contained'
                                            onClick={onPress}
                                            disabled={loadingInvoice}
                                            sx={{ minWidth: 120, height: 40, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                                        >
                                            {loadingInvoice ? <CircularProgress color="inherit" size={24} /> : 'View Invoice'}
                                        </Button>
                                    </div>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Payment Method</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{paymentMethod_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Total Price</Typography>
                                    {/* <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{`Rp ${formatCurrency(totalPrice_)}`}</strong></Typography> */}
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{formatCurrency(totalPrice_)}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Services Fee</Typography>
                                    {/* <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{`Rp ${formatCurrency(servicesFee_)}`}</strong></Typography> */}
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{formatCurrency(servicesFee_)}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Total Promo Applied</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{formatCurrency(totalPromoApplied_)}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>TAX</Typography>
                                    {/* <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{`Rp ${formatCurrency(tax_)}`}</strong></Typography> */}
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{formatCurrency(tax_)}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Grand Total</Typography>
                                    {/* <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{`Rp ${formatCurrency(grandTotal_)}`}</strong></Typography> */}
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{formatCurrency(grandTotal_)}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Payment Date</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{GLOBAL.formatDateWithTimeSecond(paymentDate_)}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Source</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{source_}</strong></Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography style={{ color: '#737373', fontSize: 14, fontWeight: '400' }}>Source Type</Typography>
                                    <Typography style={{ color: '#000000', fontSize: 16, fontWeight: '500' }}><strong>{sourceType_}</strong></Typography>
                                </Grid>
                            </Grid>
                        </>
                    )}
                </Container>
            </DrawerLongWidth>
            <Notification
                open={notification.open}
                onClose={() => setNotification({ ...notification, open: false })}
                isError={notification.isError}
                message={notification.message}
            />
        </>
    )
}

export default Details
